<template>
	<div>
		<v-layout wrap justify-end
			align-center class="header-booking-data">
			<amounts-component :subsidiary-id="subsidiary" />
			<v-flex xs2>
				<v-select
					class="filter-select"
					hide-details
					:items="subsidiaries"
					item-text="name"
					item-value="id"
					single-line
					v-model="subsidiary"
					@input="loadTypeRooms"
					@change="onChangeSubsidiary"
				>
				</v-select>
			</v-flex>
		</v-layout>
		<v-layout
			v-if="bookingCode && bookingSelected && bookingSelected.summary
				&& bookingSelected.summary.personalInformation"
			row wrap justify-end align-center
			class="header-booking-data header-booking-data-calendar">
			<v-flex xs8 pr-3>
				<p>Cliente</p>
				<span>
					{{ bookingSelected.summary.personalInformation.name }}
					{{ bookingSelected.summary.personalInformation.lastName }}
				</span>
			</v-flex>
			<v-flex xs1>
				<p>Cod. Reserva</p>
				<span>{{ bookingCode }}</span>
			</v-flex>
			<v-flex xs1 pr-3>
				<p>Habitación</p>
				<span>{{ bookingSelected.summary.personalInformation.roomTypeCode }} {{ roomList.codeRoom }}</span>
			</v-flex>
			<v-flex xs2 pr-0>
				<v-layout row wrap align-center>
					<v-flex xs8>
						<v-select
							class="filter-select filter-header-calendar"
							v-bind:items="roomsList"
							label="Nº"
							item-text="codeRoom"
							v-model="roomList"
							:disabled="roomsList.length === 0"
							hide-details
							single-line
							bottom>
						</v-select>
					</v-flex>
					<v-flex xs4>
						<v-btn
							type="button"
							class="assign-room"
							:disabled="!roomList"
							@click="assignBooking">
							Asignar
						</v-btn>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
		<div class="container-calendar mt-3">
			<div class="tasks-calendar-header">
				<v-layout row wrap align-center>
					<v-flex xs3 pr-2>
						<v-layout row wrap class="calendar-range">
							<v-flex md6 pa-0 class="border-right">
								<v-menu
									lazy
									v-model="menuStart"
									transition="scale-transition"
									offset-y
									full-width
									:nudge-left="40"
									class="menu-date-picker"
									max-width="290px"
									v-on:input="changeIcon">
									<v-text-field
										slot="activator"
										label="Picker in menu"
										v-model="dateStart"
										prepend-icon="event"
										:append-icon="arrowIconStart"
										:append-icon-cb="toggleIconStartDate"
										single-line
										hide-details
										readonly
									></v-text-field>
									<v-date-picker
										v-model="dateStart"
										locale="es-PE"
										:date-format="changeFormatDate"
										:formatted-value="formatted"
										no-title
										scrollable>
									</v-date-picker>
								</v-menu>
							</v-flex>
							<v-flex md6 py-0 pl-1>
								<v-menu
									lazy
									v-model="menuEnd"
									transition="scale-transition"
									offset-y
									full-width
									class="menu-date-picker"
									max-width="290px"
									@input="changeEndIcon">
									<v-text-field
										slot="activator"
										label="Picker in menu"
										v-model="dateEnd"
										:append-icon="arrowIconEnd"
										:append-icon-cb="toggleIconEndDate"
										single-line
										hide-details
										readonly
									></v-text-field>
									<v-date-picker
										v-model="dateEnd"
										locale="es-PE"
										:date-format="changeFormatDate"
										:formatted-value="formatted"
										no-title
										scrollable
										:allowed-dates="(date) => isAfterMethod(date, dateStart)"
										@input="showDates">
									</v-date-picker>
								</v-menu>
							</v-flex>
						</v-layout>
					</v-flex>
					<v-flex xs6>
						<v-layout row wrap justify-start class="caption">
							<v-flex xs2>
								<span class="color check-in"></span>
								<label class="title">
									Check In
								</label>
							</v-flex>
							<v-flex xs2>
								<span class="color check-out"></span>
								<label class="title">
									Check Out
								</label>
							</v-flex>
							<v-flex xs2>
								<span class="color taken"></span>
								<label class="title">
									Reservada
								</label>
							</v-flex>
							<v-flex xs2>
								<span class="color locked"></span>
								<label class="title">
									Bloqueada
								</label>
							</v-flex>
							<v-flex xs2>
								<span class="color in-house"></span>
								<label class="title">
									In House
								</label>
							</v-flex>
						</v-layout>
					</v-flex>
					<v-flex xs3>
						<v-layout row wrap justify-end class="container-actualizar">
							<v-flex xs3 pr-3>
								<v-btn 
								small 
								class="btn-action btn-darkblue white--text"
								@click="loadAvailability">
									<v-icon>autorenew</v-icon>
								</v-btn>
							</v-flex>
							<v-flex xs6>
									<button-create 
										text="Crear reserva" 
										@function-click="goToBookingNew"
										:btn-function="true"></button-create>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-layout>
			</div>
			<div class="base-calendar"  ref="base-calendar">
				<transition name="fade" mode="out-in">
					<div class="date-bar-fixed" v-show="showDateBarFixed" ref="bar-fixed">
						<div class="row-calendar row-days row-taken-bar">
							<div
								v-for="day in monthSelected.days"
								:key="day.id"
								class="col-calendar col-calendar-1">
								<p>{{ day.shortDay }}</p>
								<span>{{ day.day }}</span>
							</div>
						</div>
					</div>
				</transition>
				<div class="thead-calendar">
					<div class="main-row">
						<div class="col-calendar col-calendar-4" ref="col">
							<div class="row-calendar row-left row-taken-bar">
								<div class="select">
									<v-select
										class="filter-select select-roomtype"
										label="Tipo de Habitación"
										hide-details
										item-text="codeRoomtype"
										item-value="id"
										single-line
										:items="roomTypes"
										@change="loadData"
										v-model="roomTypeSelected">
									</v-select>
								</div>
							</div>
							<div class="row-calendar row-left row-taken-bar">
								<span class="taken-bar">Ocupación</span>
							</div>
							<div v-for="room in rooms"
								:key="room.id"
								class="row-calendar row-rooms row-left">
								<p class="row-rooms-text">
									{{ room.typeRoom.code }} {{ room.codeRoom }}
								</p>
							</div>
							<div class="row-calendar row-left row-left-footer">
								<p class="text-footer">Disponible:</p>
							</div>
							<div class="row-calendar row-left row-left-footer">
								<p class="text-footer">Tarifa:</p>
							</div>
							<div class="row-calendar row-left row-left-footer">
								<p class="text-footer text-xs-center px-0">Diponibilidad</p>
								<p class="text-footer text-xs-center px-0">General</p>
							</div>
						</div>
						<div class="col-calendar col-calendar-31" ref="col-calendar-31">
							<div class="row-calendar row-days row-taken-bar" ref="movil-date" id="movil-date">
								<div
									v-for="day in monthSelected.days"
									:key="day.id"
									class="col-calendar col-calendar-1">
									<p>{{ day.shortDay }}</p>
									<span>{{ day.day }}</span>
								</div>
							</div>
							<div class="row-calendar row-days row-taken-bar">
								<div
									v-for="(taken, takenIndex) in roomsTaken"
									:key="takenIndex"
									class="col-calendar col-calendar-1 py-1">
									<p>{{ taken.percent }}%</p>
								</div>
							</div>
							<div
								v-for="room in rooms"
								:key="room.id"
								class="row-calendar row-calendar-body">
								<div
									v-for="(day, dayIndex) in monthSelected.days"
									:key="day.id"
									class="col-calendar col-calendar-1"
									:class="{ 'day-is-weekend' : day.isWeekend,
										'day-is-selected' : day.isSelected && room.isSelected,
										'day-is-taken' : dayTaken(room, day) }">
									<div
										v-if="dayTaken(room, day)"
										class="tag-container"
										draggable="true"
										droppable="true"
										@dragover.prevent
										@drag="dragEvent(room, day)"
										@drop="dropEvent(room, day, $event)"
										@click.stop="newBooking($event, day, room)">
										<div
											v-for="(customer, customerIndex) in room.customers"
											:key="customerIndex"
											class="tag"
											:class="{ 'tag-init-day' : customer.initDay === day.day,
												'tag-end-day' : customer.endDay === day.day,
												'z-index' : dayIndex === 0 && showName(dayIndex, customer, day.day) }"
											readonly
											:style="`background-color: ${customer.color};`"
											@click.stop="showCustomerInfo($event, room, customer, day)"
											v-if="validationTakenDay(customer, day)">
											<span v-if="customer.initDay === day.day || showName(dayIndex, customer, day.day)"
												class="tag-name"
												:style="`max-width: calc((100% * ${calculateLength(dayIndex, customer, day.day)}) - 18px)`">
												{{ customer.lastname }} {{ customer.name }}
											</span>
										</div>
									</div>
									<div
										v-if="newRanges.length !== 1
											|| (newRanges[0]
											&& methodIsAfter(newRanges[0].day.date, day.date))
											|| (newRanges[0] && (newRanges[0].room.id !== room.id))
											|| (newRanges[0]
											&& methodIsSameDay(newRanges[0].day.date, day.date))"
										class="tag-container no-tag"
										draggable="true"
										droppable="true"
										@dragover.prevent
										@drag="dragEvent(room, day)"
										@drop="dropEvent(room, day, $event)"
										@click.stop="newBooking($event, day, room)">
									</div>
									<div
										v-else
										class="tag-container no-tag"
										draggable="true"
										droppable="true"
										@dragover.prevent
										@drag="dragEvent(room, day)"
										@drop="dropEvent(room, day, $event)"
										@click.stop="newBooking($event, day, room)">
									</div>
								</div>
							</div>
							<div class="row-calendar row-calendar-footer">
								<div
									v-for="(free, freeIndex) in freeRooms"
									:key="freeIndex"
									class="col-calendar col-calendar-1">
									<p class="text-footer">{{ free.free }}</p>
								</div>
							</div>
							<div class="row-calendar row-calendar-footer">
								<div
									v-for="(free, freeIndex) in freeRooms"
									:key="freeIndex"
									class="col-calendar col-calendar-1">
									<p class="text-footer">{{ free.currency }}{{ free.price | round }}</p>
								</div>
							</div>
							<div class="row-calendar row-calendar-footer row-calendar-total-availability">
								<general-availability
									:free-rooms="freeRooms"
									:subsidiary-id="subsidiary"
									:month-selected="monthSelected"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<v-menu
			v-model="menuBooking"
			class="tag-menu-modal"
			content-class="tag-menu-content"
			min-width="368"
			:nudge-top="145"
			:nudge-left="40"
			position-absolutely
			:position-x="xBooking"
			:position-y="yBooking"
			z-index="10">
			<v-list class="py-0 tag-menu-header">
				<v-list-tile>
					<v-list-tile-title class="tag-menu-title">
						Check in
					</v-list-tile-title>
					<v-list-tile-action class="justify-end">
						<v-btn
							icon
							class="grey--text size-btn"
							@click="closeMenuBooking">
							<v-icon>close</v-icon>
						</v-btn>
					</v-list-tile-action>
				</v-list-tile>
			</v-list>
			<v-divider></v-divider>
			<v-layout row wrap>
				<v-flex xs7 class="tag-menu-border">
					<v-list class="tag-menu-body">
						<v-list-tile>
							<v-list-tile-title>
								<label>Booking ID:</label>
								<span>{{ customerInfo.customer.numReservation }}</span>
							</v-list-tile-title>
						</v-list-tile>
						<v-list-tile>
							<v-list-tile-title>
								<label>Nombre:</label>
								<span>
									{{ customerInfo.customer.name }}
									{{ customerInfo.customer.lastname }}
								</span>
							</v-list-tile-title>
						</v-list-tile>
						<v-list-tile>
							<v-list-tile-title>
								<label>País:</label>
								<span>{{ customerInfo.customer.country }}</span>
							</v-list-tile-title>
						</v-list-tile>
						<v-list-tile>
							<v-list-tile-title>
								<label>Check-in Date:</label>
								<span>
									{{ customerInfo.customer.dateRange[0] | parseDate }}
								</span>
							</v-list-tile-title>
						</v-list-tile>
						<v-list-tile>
							<v-list-tile-title>
								<label>Check-out date:</label>
								<span>
									{{ customerInfo.customer.dateRange[1] | parseDate }}
								</span>
							</v-list-tile-title>
						</v-list-tile>
						<v-list-tile>
							<v-list-tile-title>
								<label>Hora de salida:</label>
								<span>
									{{ getCheckoutHours(customerInfo.customer.dateRange[1]) }}
								</span>
							</v-list-tile-title>
						</v-list-tile>
						<v-list-tile>
							<v-list-tile-title>
								<label>Exonerado:</label>
								<span>{{ customerInfo.exonerated }}</span>
							</v-list-tile-title>
						</v-list-tile>
						<v-list-tile>
							<v-list-tile-title>
								<label>Pago sin igv:</label>
								<span>${{ customerInfo.customer.total | round }}</span>
							</v-list-tile-title>
						</v-list-tile>
						<v-list-tile>
							<v-list-tile-title>
								<label>Pago total:</label>
								<span>${{ customerInfo.customer.totalIgv | round }}</span>
							</v-list-tile-title>
						</v-list-tile>
						<v-list-tile>
							<v-list-tile-title>
								<label>Consumo:</label>
								<span>${{ customerInfo.customer.subTotalConsumptions | round }}</span>
							</v-list-tile-title>
						</v-list-tile>
						<v-list-tile>
							<v-list-tile-title>
								<label>Adultos:</label>
								<span>{{ customerInfo.customer.adults }}</span>
							</v-list-tile-title>
						</v-list-tile>
						<v-list-tile>
							<v-list-tile-title>
								<label>Niños:</label>
								<span>{{ customerInfo.customer.childrens }}</span>
							</v-list-tile-title>
						</v-list-tile>
					</v-list>
				</v-flex>
				<v-flex xs5>
					<v-list class="tag-menu-sidebar">
						<v-list-tile
							@click="seeBooking">
							<v-list-tile-action>
								<v-icon>remove_red_eye</v-icon>
							</v-list-tile-action>
							<v-list-tile-title>Visualizar</v-list-tile-title>
						</v-list-tile>
						<v-list-tile
							v-if="(Number(customerInfo.customer.bookingState) === 4
								&& !expiredReservation)
								|| (Number(customerInfo.customer.bookingState) === 1
								&& !expiredReservation)"
							@click="goToCheckIn(customerInfo.room.comSubsidiaryId,
								customerInfo.room.hotMsRoomtypeId)">
							<v-list-tile-action>
								<img :src="`${$imageS3}/clerkinn/checkin-icon.svg`" alt="">
							</v-list-tile-action>
							<v-list-tile-title>Check in</v-list-tile-title>
						</v-list-tile>
						<v-list-tile
							@click="goToCheckOut(customerInfo.room.comSubsidiaryId,
								customerInfo.room.hotMsRoomtypeId)"
							v-if="validationCheckOut(customerInfo)">
							<v-list-tile-action>
								<img :src="`${$imageS3}/clerkinn/checkout-icon.svg`" alt="">
							</v-list-tile-action>
							<v-list-tile-title>Check Out</v-list-tile-title>
						</v-list-tile>
						<v-list-tile
							@click="openNoShowBooking"
							v-if="noShowOption(customerInfo)">
							<v-list-tile-action>
								<img :src="`${$imageS3}/clerkinn/no-show-icon.svg`" alt="">
							</v-list-tile-action>
							<v-list-tile-title>No show</v-list-tile-title>
						</v-list-tile>
						<v-list-tile
							@click="openCancelBooking"
							v-if="Number(customerInfo.customer.bookingState) === 1
								|| Number(customerInfo.customer.bookingState) === 4">
							<v-list-tile-action>
								<v-icon class="red--text">cancel</v-icon>
							</v-list-tile-action>
							<v-list-tile-title>Anular</v-list-tile-title>
						</v-list-tile>
						<v-list-tile
							@click="downloadCardTravel">
							<v-list-tile-action>
								<v-icon>print</v-icon>
							</v-list-tile-action>
							<v-list-tile-title>Tarjeta de Embarque</v-list-tile-title>
						</v-list-tile>
						<v-list-tile
							@click="goToBilling(customerInfo.room.comSubsidiaryId,
								customerInfo.room.hotMsRoomtypeId)"
							>
							<v-list-tile-action>
								<img :src="`${$imageS3}/clerkinn/billing-icon.svg`" alt="">
							</v-list-tile-action>
							<v-list-tile-title>Factura</v-list-tile-title>
						</v-list-tile>
						<v-list-tile
							@click="goToPrepayment(customerInfo)"
							v-if="validationAdvancePayment(customerInfo)">
							<v-list-tile-action>
								<img :src="`${$imageS3}/clerkinn/pay-icon.svg`" alt="">
							</v-list-tile-action>
							<v-list-tile-title>Adelanto</v-list-tile-title>
						</v-list-tile>
						<v-list-tile
							@click="goToDetailGuest(customerInfo.room.comSubsidiaryId,
								customerInfo.room.hotMsRoomtypeId)"
							>
							<v-list-tile-action>
								<img :src="`${$imageS3}/clerkinn/billing-icon.svg`" alt="">
							</v-list-tile-action>
							<v-list-tile-title>Detalle de Huésped</v-list-tile-title>
						</v-list-tile>
					</v-list>
				</v-flex>
			</v-layout>
		</v-menu>
		<v-menu
			v-model="menuNewBooking"
			class="tag-menu-modal new-booking"
			content-class="tag-menu-content new-booking"
			position-absolutely
			min-width="148"
			:position-x="xNewBooking"
			:position-y="yNewBooking"
			:nudge-top="36"
			:nudge-left="20">
			<v-list class="py-0 tag-menu-header">
				<v-list-tile>
					<v-list-tile-title class="tag-menu-title">
						Reserva
					</v-list-tile-title>
					<v-list-tile-action class="justify-end">
						<v-btn
							icon
							class="grey--text size-btn"
							@click="closeMenuNew">
							<v-icon>close</v-icon>
						</v-btn>
					</v-list-tile-action>
				</v-list-tile>
			</v-list>
			<v-divider></v-divider>
			<v-layout row wrap>
				<v-flex xs12>
					<v-list class="tag-menu-sidebar">
						<v-list-tile
							@click="goToReserve">
							<v-list-tile-action>
								<v-icon>add</v-icon>
							</v-list-tile-action>
							<v-list-tile-title>Agregar</v-list-tile-title>
						</v-list-tile>
					</v-list>
				</v-flex>
			</v-layout>
		</v-menu>
		<v-dialog
			v-model="modalCancelBooking"
			persistent
			width="480px">
			<v-card>
				<v-card-title class="headline py-2 px-5">
					<v-layout row wrap align-center>
						<v-flex xs6 text-xs-left>
							<p class="headline-title">
								Anulación de reserva
							</p>
						</v-flex>
						<v-flex xs6 text-xs-right>
							<label class="headline-label">
								Fecha:
							</label>
							{{ today }}
						</v-flex>
					</v-layout>
				</v-card-title>
				<v-card-text class="px-5">
					<v-layout row wrap
						text-xs-left>
						<v-flex xs6>
							<label class="label-title">Motivo</label>
							<v-text-field
								class="input-border-inset"
								v-model="cancelModel.title">
							</v-text-field>
							<span class="caption red--text"
								v-if="$v.cancelModel.title && $v.cancelModel.title.$invalid">
								El motivo de anulación es requerido
							</span>
						</v-flex>
						<v-flex xs12 mt-3>
							<label class="label-title">Descripción</label>
							<v-text-field
								class="input-border-inset input-textarea input-note"
								no-resize
								multi-line
								:rows="3"
								textarea
								v-model="cancelModel.description"
							></v-text-field>
							<span class="caption red--text"
								v-if="$v.cancelModel.description && $v.cancelModel.description.$invalid">
								La descripción de la anulación es requerida
							</span>
						</v-flex>
					</v-layout>
				</v-card-text>
				<v-card-actions>
					<v-layout row wrap justify-center>
						<v-flex xs3 pr-2>
							<v-btn
								class="btn-cancel grey"
								@click.native="closeBookingModal('Cancel')">
								Cancelar
							</v-btn>
						</v-flex>
						<v-flex xs3 pl-2>
							<v-btn
								class="btn-save"
								:disabled="$v.$invalid"
								@click.native="cancelBooking">
								Aceptar
							</v-btn>
						</v-flex>
					</v-layout>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog
			v-model="modalNoShowBooking"
			persistent
			width="380px">
			<v-card>
				<v-card-title class="headline py-2 px-4">
					<v-layout row wrap align-center>
						<v-flex xs12 text-xs-left>
							<p class="headline-title">
								No-show de reserva
							</p>
						</v-flex>
					</v-layout>
				</v-card-title>
				<v-card-text class="px-4">
					<v-layout row wrap
						text-xs-left>
						<v-flex xs6>
							<label class="headline-label">
								Booking ID:
							</label>
							{{ noShowModel.codeBooking }}
						</v-flex>
						<v-flex xs6>
							<label class="headline-label">
								Nombre:
							</label>
							{{ customerInfo.customer.name }}
							{{ customerInfo.customer.lastname }}
						</v-flex>
						<v-flex xs6 mt-2>
							<label class="label-title">No-show</label>
							<v-menu
								lazy
								v-model="noShowDate"
								transition="scale-transition"
								offset-y
								full-width
								class="menu-date-picker mt-2"
								max-width="290px"
								@input="changeIconDate">
								<v-text-field
									slot="activator"
									label="Fecha de nacimiento"
									v-model="noShowModel.date"
									prepend-icon="event"
									:append-icon="arrowIcon"
									single-line
									hide-details
									readonly
								></v-text-field>
								<v-date-picker
									v-model="noShowModel.date"
									locale="es-PE"
									year-icon
									scrollable>
								</v-date-picker>
							</v-menu>
						</v-flex>
						<v-flex xs12 mt-3>
							<v-checkbox
								class="input-checkbox input-booking"
								label="Facturar"
								v-model="noShowModel.flagBilling"
								color="info"
								hide-details>
							</v-checkbox>
						</v-flex>
					</v-layout>
				</v-card-text>
				<v-card-actions>
					<v-layout row wrap justify-center>
						<v-flex xs4 pr-2>
							<v-btn
								class="btn-cancel grey"
								@click.native="closeBookingModal('NoShow')">
								Cancelar
							</v-btn>
						</v-flex>
						<v-flex xs4 pl-2>
							<v-btn
								class="btn-save"
								@click.native="noShowBooking">
								Aceptar
							</v-btn>
						</v-flex>
					</v-layout>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog
			v-model="modalSeeBooking"
			persistent
			width="783px">
			<v-card>
				<v-card-title class="headline py-2 pl-5">
					<v-layout row wrap align-center>
						<v-flex xs3 text-xs-left>
							<p class="headline-title">
								Visualizar reserva
							</p>
						</v-flex>
						<v-flex xs3 text-xs-right pl-0>
							<label class="headline-label">
								Booking ID:
							</label>
							{{ seeModel.numReservation }}
						</v-flex>
						<v-flex xs6 text-xs-right>
							<v-btn
								color="grey"
								icon
								@click="closeBookingModal('See')"
							>
								<v-icon>close</v-icon>
							</v-btn>
						</v-flex>
					</v-layout>
				</v-card-title>
				<v-card-text class="px-0">
					<v-layout row wrap px-2>
						<v-flex xs12>
							<div class="bar-data">
								<div class="bar-data-item">
									<p>
										Fecha de reserva:
										<span>{{ seeModel.bookingDate | parseDate }}</span>
									</p>
								</div>
								<div class="bar-data-item">
									<p>
										Llegada:
										<span>{{ seeModel.bookingStart | parseDate }}</span>
									</p>
								</div>
								<div class="bar-data-item">
									<p>
										Salida:
										<span>{{ seeModel.bookingEnd | parseDate }}</span>
									</p>
								</div>
								<div class="bar-data-item">
									<p>
										Noches:
										<span>{{ seeModel.numberNights }}</span>
									</p>
								</div>
								<div class="bar-data-item no-border">
									<p>
										Huésped:
										<span>{{ seeModel.quantity }}</span>
									</p>
								</div>
							</div>
						</v-flex>
					</v-layout>
					<v-layout wrap px-4>
						<v-flex xs2 ml-1>
							<v-btn
								flat
								class="blue--text"
								@click="goToCheckIn(customerInfo.room.comSubsidiaryId,
									customerInfo.room.hotMsRoomtypeId)"
							>
								Editar Clientes
							</v-btn>
						</v-flex>
					</v-layout>
					<v-layout row wrap mb-2
						text-xs-left px-5>
						<v-flex xs3>
							<label class="modal-label">
								Nº Tarjeta
							</label>
							<p class="modal-text mt-2">{{ seeModel.customer.data.cardVip }}</p>
						</v-flex>
						<v-flex xs3>
							<label class="modal-label">
								Tipo de identificación
							</label>
							<p class="modal-text mt-2">
								{{ seeModel.customer.data.documentName }}:
								{{ seeModel.customer.data.numDocument }}
							</p>
						</v-flex>
						<v-flex xs3>
							<label class="modal-label">
								Apellidos y Nombres
							</label>
							<p class="modal-text mt-2">
								{{ seeModel.customer.data.lastname }},
								{{ seeModel.customer.data.name }}
							</p>
						</v-flex>
						<v-flex xs3>
							<label class="modal-label">
								Correo electrónico
							</label>
							<p class="modal-text mt-2">{{ seeModel.customer.data.email }}</p>
						</v-flex>
					</v-layout>
					<v-layout wrap v-if="seeModel.customerAditional" pl-5 mb-1>
						<label>Huéspedes adicionales:</label>
					</v-layout>
					<v-layout row wrap mb-4
						text-xs-left px-5
						v-for="customerAditional in seeModel.customerAditional"
						:key="customerAditional.id">
						<v-flex xs3>
							<label class="modal-label">
								Tipo de identificación
							</label>
							<p class="modal-text mt-2">
								{{ customerAditional.documentName }}:
								{{ customerAditional.numDocument }}
							</p>
						</v-flex>
						<v-flex xs3>
							<label class="modal-label">
								Apellidos y Nombres
							</label>
							<p class="modal-text mt-2">
								{{ customerAditional.lastname }},
								{{ customerAditional.name }}
							</p>
						</v-flex>
						<v-flex xs3>
							<p class="modal-text mt-4">{{ customerAditional.flagPerson }}</p>
						</v-flex>
					</v-layout>
					<v-layout row wrap>
						<v-flex xs12>
							<v-divider></v-divider>
						</v-flex>
					</v-layout>
					<v-layout row wrap my-4
						text-xs-left px-5
						v-if="seeModel.channel">
						<v-flex xs12 mb-3>
							<label class="modal-label pr-2">Segmento:</label>
							<span class="modal-text">{{ seeModel.channel.data.name }}</span>
						</v-flex>
						<v-flex xs2 mr-3
							v-for="(value, key) in seeModel.channel.data.questions"
							:key="key">
							<label class="modal-label">
								{{ key }}
							</label>
							<p class="modal-text mt-2">
								{{ value }}
							</p>
						</v-flex>
					</v-layout>
				</v-card-text>
				<v-card-actions>
					<v-layout row wrap justify-center>
						<v-flex xs2 pr-2>
							<v-btn
								class="btn-cancel grey"
								@click.native="closeBookingModal('See')">
								Cerrar
							</v-btn>
						</v-flex>
						<v-flex xs2 pl-2>
							<v-btn
								class="btn-success white--text"
								:disabled="expiredReservation"
								@click.native="goToUpdateBooking">
								Editar
							</v-btn>
						</v-flex>
					</v-layout>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
	import ButtonCreate from '@/components/shared/ButtonCreate';
	import { required } from 'vuelidate/lib/validators';
	import { addDays, eachDay, format, getDate, getDay, getYear,
		getMonth, isAfter, isSameDay, isWeekend,
		addMonths, differenceInDays, subDays, isDate, differenceInHours } from 'date-fns';
	import esLocale from 'date-fns/locale/es';
	import helper from '@/shared/helper';
	import mixin from '@/shared/mixins';
	import { parseDate, round } from '@/shared/filters';
	import amountsComponent from '@/components/shared/AmountsComponent';
	import generalAvailability from './subComponents/GeneralAvailability';

	const helperMethods = helper.methods;

	async function loadAvailability() {
		const params = {
			dateStart: this.dateStart,
			idSubsidiary: this.subsidiary,
			dateEnd: this.dateEnd,
			roomTypeIdSelect: this.roomTypeSelected,
		};
		try {
			await this.$http.patch(`${process.env.PMS_URL}/subsidiary/availability`, { ...params });
			this.loadData();
			this.showNotification('Se realizo con exito la actualizaciòn');
		} catch (err) {
			if (err.status === 405) {
				this.showNotification('Error al Actualizar');
			}
		}
	}

	function mounted() {
		this.setYearSelected();
		if (this.bookingCode && (this.bookingCode !== undefined)
			&& (this.bookingCode !== null)) {
			this.loadBooking(this.bookingCode);
		}
		this.loadParams();
		this.fixedBarDateCalculations();
	}

	function fixedBarDateCalculations() {
		const mainEl = this.$refs['base-calendar'];
		const el = this.$refs['movil-date'];
		const initialPositionY = el.getBoundingClientRect().y;
		const initialPositionX = el.getBoundingClientRect().x;
		const colWidth = this.$refs.col.offsetWidth;
		const barFixed = this.$refs['bar-fixed'];
		const innerContainer = this.$refs['col-calendar-31'];
		const gap = initialPositionX - colWidth;
		mainEl.addEventListener('scroll', () => {
			const { x, y } = el.getBoundingClientRect();
			barFixed.style.transform = `translateX(${x - gap}px)`;
			this.showDateBarFixed = initialPositionY > y + 15;
		});
		innerContainer.addEventListener('scroll', () => {
			const { x } = el.getBoundingClientRect();
			barFixed.style.transform = `translateX(${x - gap}px)`;
		});
	}

	function arrowIcon() {
		const arrow = this.onChangeDate ? 'arrow_drop_up' : 'arrow_drop_down';
		return arrow;
	}

	function arrowIconEnd() {
		const arrow = this.onChangeEnd ? 'arrow_drop_up' : 'arrow_drop_down';
		return arrow;
	}

	function arrowIconStart() {
		const arrow = this.onChange ? 'arrow_drop_up' : 'arrow_drop_down';
		return arrow;
	}

	async function assignBooking() {
		const model = {
			codeBooking: this.bookingCode,
			idRoom: this.roomList.id,
		};
		try {
			await this.$http.post(`${process.env.PMS_URL}/booking/asignedroom`, model);
			this.showNotification('La habitación se asignó correctamente.', 'success');
			this.bookingSelected = null;
			const query = {
				initDate: this.dateStart,
				endDate: this.dateEnd,
				roomId: this.roomList.id,
				bookingCode: this.bookingCode,
			};
			let isToday = false;
			const allDays = eachDay(this.dateStart, this.dateEnd);
			allDays.forEach((d) => {
				if ((differenceInDays(new Date(), d) === 0)
					&& (differenceInDays(new Date(), d) !== -0)) {
					isToday = true;
				}
			});
			if (isToday) {
				this.goToCheckIn(this.subsidiary, this.roomTypeSelected, query);
			} else {
				this.$router.push({ name: 'cms-calendar', params: { bookingCode: null } });
			}
		} catch (err) {
			const message = err.data.message;
			if (err.status === 405) {
				if (message === 'BOOKING_NOT_AVAILABLE_RANGE') {
					this.showNotification('La habitación ya cuenta con una reserva dentro de las fechas seleccionadas.', 'error');
				}
			}
		}
	}

	function bookingCode(code) {
		return this.loadBooking(code);
	}

	function calculateLength(dayIndex, { allDaysOnInitMonth, dates, initDay }, day) {
		let showInDay = false;
		let newDay = day;
		for (let index = 0; index < dates; index += 1) {
			if ((initDay + (index + 1)) === day) {
				showInDay = true;
				newDay = day;
			}
		}
		const length = (dayIndex === 0) && showInDay ?
			(allDaysOnInitMonth.length - (newDay - initDay)) : allDaysOnInitMonth.length;
		return length;
	}

	async function cancelBooking() {
		const codeBooking = this.customerInfo.customer.bookingCode;
		await this.$http.put(`${process.env.PMS_URL}/reserve/${codeBooking}`, this.cancelModel);
		this.showNotification('La reserva ha sido anulada correctamente.', 'success');
		this.loadData();
		this.closeBookingModal('Cancel');
	}

	function changeEndIcon(result) {
		this.onChangeEnd = result;
	}

	function changeFormatDate(value) {
		return new Date(value).toISOString().substr(0, 10);
	}

	function changeIcon(result) {
		this.onChange = result;
	}

	function changeIconDate(result) {
		this.onChangeDate = result;
	}

	function closeBookingModal(type) {
		this[`modal${type}Booking`] = false;
		if (type === 'Cancel') {
			this.cancelModel = {
				description: '',
				title: '',
			};
		}
		if (type === 'NoShow') {
			this.noShowModel = {
				codeBooking: '',
				date: format(new Date(), 'YYYY-MM-DD'),
				flagBilling: false,
			};
		}
	}

	function closeMenuBooking() {
		this.menuBooking = false;
		this.customerInfo = {
			customer: { id: null, dateRange: [], allDaysOnInitMonth: [] },
		};
	}

	function closeMenuNew() {
		this.menuNewBooking = false;
		this.newRanges = [];
	}

	function daysByMonth() {
		const days = eachDay(this.dateStart, this.dateEnd);
		const daysComplete = days.map((day, index) => {
			const newDay = { ...day };
			newDay.id = index + 1;
			newDay.date = day;
			newDay.day = getDate(day);
			newDay.value = getDay(day);
			newDay.isWeekend = isWeekend(day);
			newDay.shortDay = this.shortDays[getDay(day)];
			newDay.month = getMonth(day) + 1;
			newDay.menuNew = false;
			if ((index + 1) === days.length) {
				this.monthSelected.endMonth = getMonth(day) + 1;
			}
			return newDay;
		});
		return daysComplete;
	}

	async function downloadCardTravel() {
		const baseUrl = process.env.PMS_URL;
		const code = this.customerInfo.customer.bookingCode;
		const typeDocumentCode = 'registerCard';
		const name = `TARJETA-DE-EMBARQUE${code}`;
		const responseType = 'blob';
		const cardModel = { details: [{}] };
		const response = await this.$http.post(`${baseUrl}/booking/${code}/report/${typeDocumentCode}`,
			cardModel, { responseType });
		const blob = helperMethods.generateBlob(response.bodyBlob);
		helperMethods.showDownloadDialog(blob, name, 'pdf');
	}

	function dragEvent(room, day) {
		this.roomSelected = room;
		this.daySelected = day;
		const customerInRooms = this.rooms.map((r) => {
			const newR = Object.assign({}, r);
			if (r.id === room.id) {
				newR.customer = r.customers.find(c => c.allDaysOnInitMonth.findIndex(ca =>
					ca.day === day.day && ca.month === day.month) > -1);
			}
			return newR.customer;
		});
		this.customerSelected = customerInRooms.find(cir => cir !== undefined);
	}

	async function dropEvent(room, day, event) {
		if (this.customerSelected) {
			const model = {
				codeBooking: this.customerSelected.bookingCode,
				idRoom: room.id,
				checkIn: format(new Date(day.date), 'YYYY-MM-DD'),
				checkOut: format(new Date(addDays(day.date, this.customerSelected.dates - 1)),
					'YYYY-MM-DD'),
			};
			try {
				await this.$http.put(`${process.env.PMS_URL}/booking/asignedroom`, model);
				this.showNotification('La reserva se modificó correctamente.', 'success');
			} catch (err) {
				const message = err.data.message;
				if (err.status !== 500) {
					if (message === 'BOOKING_NOT_AVAILABLE_RANGE') {
						this.showNotification('La habitación ya cuenta con una reserva dentro de las fechas seleccionadas.', 'error');
					}
					if (message === 'BOOKING_CANT_UPDATE_CURRENT_ONE') {
						this.showNotification('La reserva no se puede mover a fechas anteriores.', 'error');
					}
				}
			} finally {
				this.loadData();
			}
		} else {
			event.preventDefault();
			this.loadData();
			this.showNotification('No ha seleccionado ninguna reserva.', 'error');
		}
		this.customerSelected = {};
		this.roomSelected = {};
		this.daySelected = {};
	}

	function expiredReservation() {
		return this.customerInfo.customer.allDaysOnInitMonth.every(d =>
			differenceInDays(d.date, new Date()) < 0);
	}

	function goToBilling(hotelId, roomTypeId, code = 'billing') {
		const query = {
			initDate: format(this.customerInfo.customer.dateRange[0], 'YYYY-MM-DD'),
			endDate: format(this.customerInfo.customer.dateRange[1], 'YYYY-MM-DD'),
			roomId: this.customerInfo.room.id,
			bookingCode: this.customerInfo.customer.bookingCode,
			active: 'tab-6',
			code,
		};
		this.$router.push({
			name: 'checkin-form-tabs',
			params: {
				hotelId,
				roomTypeId,
			},
			query,
		});
	}

	function goToCheckIn(hotelId, roomTypeId) {
		const query = {
			initDate: format(this.customerInfo.customer.dateRange[0], 'YYYY-MM-DD'),
			endDate: format(this.customerInfo.customer.dateRange[1], 'YYYY-MM-DD'),
			roomId: this.customerInfo.room.id,
			bookingCode: this.customerInfo.customer.bookingCode,
		};
		this.$router.push({
			name: 'checkin-form-tabs',
			params: {
				hotelId,
				roomTypeId,
			},
			query,
		});
	}

	function goToCheckOut(hotelId, roomTypeId) {
		let isToday = false;
		const allDays = eachDay(this.customerInfo.customer.dateRange[0],
			this.customerInfo.customer.dateRange[1]);
		allDays.forEach((d) => {
			if (differenceInDays(new Date(), d) === 0) {
				isToday = true;
			}
		});
		if (isToday) {
			const query = {
				initDate: format(this.customerInfo.customer.dateRange[0], 'YYYY-MM-DD'),
				endDate: format(this.customerInfo.customer.dateRange[1], 'YYYY-MM-DD'),
				roomId: this.customerInfo.room.id,
				bookingCode: this.customerInfo.customer.bookingCode,
				active: 'tab-2',
			};
			this.$router.push({
				name: 'checkin-form-tabs',
				params: {
					hotelId,
					roomTypeId,
				},
				query,
			});
		} else {
			this.showNotification('No es posible realizar el check out en reservas de días anteriores o futuros a la fecha actual.',
				'error');
		}
	}

	function goToPrepayment(booking) {
		this.$router.push({
			name: 'prepayment',
			params: {
				bookingCode: booking.customer.bookingCode,
			},
		});
	}

	function goToReserve() {
		let isToday = false;
		const allDays = eachDay(this.newRanges[0].day.date, this.newRanges[1].day.date);
		allDays.forEach((d) => {
			if (differenceInDays(new Date(), d) <= 0) {
				isToday = true;
			}
		});
		if (isToday) {
			this.$router.push({
				name: 'booking-new',
				query: this.checkInQuery,
			});
		} else {
			this.showNotification('No se pueden crear reservas en fechas anteriores a la actual. Modifica tu selección.', 'error');
		}
	}

	function goToUpdateBooking() {
		this.$router.push({
			name: 'booking-edit',
			params: {
				codeBooking: this.seeModel.code,
			},
		});
	}

	function hideCustomerInfo() {
		this.customerInfo = { customer: { id: 0 } };
	}

	function isAfterMethod(date, dateToCompare) {
		return differenceInDays(date, dateToCompare) > 0;
	}

	function isNoShow() {
		const diff = differenceInHours(this.customerInfo.customer.dateRange[0], new Date()) < 0;
		const afterDay = isAfter(this.customerInfo.customer.dateRange[1], new Date());
		return diff && afterDay;
	}

	async function loadBooking(code) {
		if (code) {
			const response = await this.$http.get(`${process.env.PMS_URL}/bookings/${code}/by-code`);
			this.bookingSelected = response.data.data[0];
			if (this.bookingSelected) {
				this.dateStart = format(this.bookingSelected.date_start, 'YYYY-MM-DD');
				this.dateEnd = format(this.bookingSelected.date_end, 'YYYY-MM-DD');
				this.subsidiary = this.bookingSelected.summary.personalInformation.hotelId;
				this.showDates();
				this.footer = [];
				this.freeRooms = [];
				this.rooms = [];
				this.roomsTaken = [];
				this.roomTypes = [];
			}
		} else {
			this.setYearSelected();
			this.loadParams();
			this.loadData(this.roomTypeSelected);
		}
	}

	async function loadData(id) {
		this.onChangeRoomType();
		const idRoomType = id || this.roomTypeSelected;
		const params = `dateStart=${this.dateStart}&dateEnd=${this.dateEnd}&typeRoom=${idRoomType}&idHotel=${this.subsidiary}`;
		const { data: calendar } = await this.$http.get(`${process.env.PMS_URL}/booking/calendar?${params}`);
		this.rooms = calendar.body.map((room) => {
			const newRoom = Object.assign({}, room);
			newRoom.isSelected = false;
			newRoom.days = this.monthSelected.days.map((d) => {
				const newD = Object.assign({}, d);
				newD.isTaken = false;
				room.customers.forEach((c) => {
					const allDays = eachDay(c.dateRange[0], c.dateRange[1]);
					const allDaysOnInitMonth = [...allDays];
					allDaysOnInitMonth.forEach((dm) => {
						if (isSameDay(dm, d.date)) {
							newD.isTaken = true;
						}
					});
				});
				return newD;
			});
			if (newRoom.customers.length > 0) {
				newRoom.customers = room.customers.map((customer) => {
					const newCustomer = { ...customer };
					newCustomer.initDay = getDate(customer.dateRange[0]);
					newCustomer.initMonth = getMonth(customer.dateRange[0]) + 1;
					newCustomer.initYear = getYear(customer.dateRange[0]);
					newCustomer.endDay = getDate(customer.dateRange[1]);
					newCustomer.endMonth = getMonth(customer.dateRange[1]) + 1;
					newCustomer.endYear = getYear(customer.dateRange[1]);
					const allDays = eachDay(customer.dateRange[0], customer.dateRange[1]);
					newCustomer.dates = allDays.length;
					const allDaysOnInitMonth = [...allDays];
					newCustomer.allDaysOnInitMonth = allDaysOnInitMonth.map((ad) => {
						const newAd = Object.assign({}, ad);
						newAd.day = {
							date: ad,
							day: getDate(ad),
							value: getDay(ad),
							isWeekend: isWeekend(ad),
							shortDay: this.shortDays[getDay(ad)],
							month: getMonth(ad) + 1,
							isSelected: false,
							year: getYear(ad),
						};
						return newAd.day;
					});
					newCustomer.datesOnInitMonth = allDaysOnInitMonth.length;
					if (allDays.length > allDaysOnInitMonth.length) {
						newCustomer.datesOnInitMonth = allDaysOnInitMonth.length - 1;
					}
					return newCustomer;
				});
			} else {
				const customer = {
					bookingCode: null,
					color: '#ffffff',
					country: `${process.env.DEFAULT_COUNTRY_ID}`,
					dateRange: ['', ''],
					lastname: null,
					name: null,
				};
				let allDaysOnInitMonth = [];
				const allDays = eachDay(customer.dateRange[0], customer.dateRange[1]);
				allDays.forEach((allDay) => {
					if ((getYear(allDay) === getYear(customer.dateRange[0]))
						&& ((getMonth(allDay) + 1) === (getMonth(customer.dateRange[0]) + 1))) {
						allDaysOnInitMonth.push(allDay);
					}
					if (this.monthSelected.endMonth > this.monthSelected.id
						&& this.monthSelected.endMonth === (getMonth(customer.dateRange[1]) + 1)) {
						if ((getYear(allDay) === getYear(customer.dateRange[1]))
							&& ((getMonth(allDay) + 1) === (getMonth(customer.dateRange[1]) + 1))) {
							allDaysOnInitMonth.push(allDay);
						}
					}
				});
				allDaysOnInitMonth = allDaysOnInitMonth.map((ad) => {
					const newAd = Object.assign({}, ad);
					newAd.day = {
						date: ad,
						day: getDate(ad),
						value: getDay(ad),
						isWeekend: isWeekend(ad),
						shortDay: this.shortDays[getDay(ad)],
						month: getMonth(ad) + 1,
						isSelected: false,
						year: getYear(ad),
					};
					return newAd.day;
				});
				const nullCustomer = {
					initDay: getDate(customer.dateRange[0]),
					initMonth: getMonth(customer.dateRange[0]) + 1,
					initYear: getYear(customer.dateRange[0]),
					endDay: getDate(customer.dateRange[1]),
					endMonth: getMonth(customer.dateRange[1]) + 1,
					endYear: getYear(customer.dateRange[1]),
					dates: allDays.length,
					datesOnInitMonth: allDaysOnInitMonth.length,
					allDaysOnInitMonth,
				};
				if (allDays.length > allDaysOnInitMonth.length) {
					nullCustomer.datesOnInitMonth = allDaysOnInitMonth.length - 1;
				}
				newRoom.customers.push(nullCustomer);
			}
			return newRoom;
		});
		this.footer = calendar.footer;
		this.roomsTaken = calendar.footer.map((taken) => {
			const newTaken = Object.assign({}, taken);
			const percent = Number(taken.percent);
			newTaken.percent = percent % 1 === 0 ? percent : percent.toFixed(2);
			delete newTaken.currency;
			delete newTaken.free;
			delete newTaken.occupied;
			delete newTaken.price;
			delete newTaken.total;
			return newTaken;
		});
		this.freeRooms = calendar.footer.map((free) => {
			const newFree = Object.assign({}, free);
			delete newFree.occupied;
			delete newFree.percent;
			delete newFree.total;
			return newFree;
		});
		if (this.rooms.length === 0 && this.footer.length === 0) {
			this.showNotification('No se encontró data para esta búsqueda.', 'info');
		}
	}

	async function loadParams() {
		const { data: subsidiaries } = await this.$http.get(`${process.env.PMS_URL}/hotel`);
		this.subsidiaries = subsidiaries.data || [];
		if (subsidiaries.data[0]) {
			this.subsidiary = subsidiaries.data[0].id;
		} else {
			this.subsidiary = this.bookingSelected ?
				this.bookingSelected.summary.personalInformation.hotelId : 0;
		}
	}

	async function loadRoomsList() {
		const baseUrl = process.env.PMS_URL;
		const subsidiaryId = this.subsidiary;
		const roomTypeId = this.roomTypeSelected;
		const params = {
			dateInit: format(this.bookingSelected.date_start, 'YYYY-MM-DD'),
			dateEnd: format(this.bookingSelected.date_end, 'YYYY-MM-DD'),
		};
		const response = await this.$http.get(`${baseUrl}/roomtype/${subsidiaryId}/rooms/${roomTypeId}`,
			{ params });
		this.roomsList = response.data.data;
		this.showNotification('Debe seleccionar y asignar un número de habitación a la reserva.', 'info');
	}

	async function loadTypeRooms() {
		const response = await this.$http.get(`${process.env.PMS_URL}/roomtype/${this.subsidiary}`);
		this.roomTypes = response.data.data;
		if (this.bookingSelected) {
			this.roomTypeSelected = this.bookingSelected.entity_id;
			this.loadRoomsList();
		} else {
			this.roomTypeSelected = response.data.data[0] ? response.data.data[0].id : 1;
			this.loadData();
		}
	}

	function methodIsAfter(firstDate, secondDate) {
		return isAfter(firstDate, secondDate);
	}

	function methodIsSameDay(firstDate, secondDate) {
		return isSameDay(firstDate, secondDate);
	}

	function monthActive(id, noLoadData) {
		if (id > 0) {
			let month = {};
			this.pickMonths = true;
			this.months.forEach((item) => {
				if (this.monthId === 0) {
					this.monthId = 1;
				}
				if (item.id === this.monthId) {
					month = item;
				}
			});
			const newMonth = Object.assign({}, month);
			this.dateEnd = format(addMonths(new Date(), 1), 'YYYY-MM-DD');
			this.dateStart = format(new Date(), 'YYYY-MM-DD');
			this.$nextTick(() => {
				newMonth.days = this.daysByMonth();
			});
			this.monthSelected = newMonth;
			if (!noLoadData) {
				if (this.bookingSelected) {
					this.bookingSelected = null;
					const year = new Date().getFullYear();
					this.setYearSelected(year);
					this.$router.push({ name: 'calendar' });
				}
				this.loadData();
			}
		}
	}

	function newBooking(e, day, room) {
		if (this.newRanges.length === 1) {
			if (this.newRanges[0].room.id === room.id
				&& !isSameDay(this.newRanges[0].day.date, day.date)
				&& isAfter(day.date, this.newRanges[0].day.date)) {
				let newBookingDisabled = false;
				if (isAfter(subDays(day.date, 1),
					addDays(this.newRanges[0].day.date, 1))
					|| isSameDay(subDays(day.date, 1),
					addDays(this.newRanges[0].day.date, 1))) {
					const newBookingAllDays = isSameDay(subDays(day.date, 1),
						addDays(this.newRanges[0].day.date, 1)) ?
						addDays(this.newRanges[0].day.date, 1) :
						eachDay(addDays(this.newRanges[0].day.date, 1), subDays(day.date, 1));
					room.customers.forEach((roomCustomer) => {
						if (isSameDay(this.newRanges[0].day.date,
							roomCustomer.allDaysOnInitMonth[0])
							|| isSameDay(day.date, roomCustomer.allDaysOnInitMonth[1])) {
							newBookingDisabled = true;
						} else {
							roomCustomer.allDaysOnInitMonth.forEach((roomDay) => {
								if (isDate(newBookingAllDays)) {
									if (isSameDay(newBookingAllDays, roomDay.date)) {
										newBookingDisabled = true;
									}
								} else if (newBookingAllDays.findIndex(newBookingDay =>
									isSameDay(newBookingDay, roomDay.date)) > -1) {
									newBookingDisabled = true;
								}
							});
						}
					});
				}
				if (!newBookingDisabled) {
					const initDate = format(this.newRanges[0].day.date, 'YYYY-MM-DD');
					const endDate = format(day.date, 'YYYY-MM-DD');
					this.newRanges.push({ day, room });
					this.monthSelected.days = this.monthSelected.days.map((daySelected) => {
						const newDaySelected = Object.assign({}, daySelected);
						newDaySelected.menu = false;
						if (isSameDay(daySelected.date, day.date)) {
							newDaySelected.isSelected = true;
							newDaySelected.menu = true;
						}
						return newDaySelected;
					});
					this.checkInQuery = {
						initDate,
						endDate,
						hotelId: this.subsidiary,
						roomTypeId: this.roomTypeSelected,
						roomId: this.newRanges[0].room.id,
					};
					this.menuBooking = false;
					e.preventDefault();
					this.menuNewBooking = true;
					this.xNewBooking = e.clientX;
					this.yNewBooking = e.clientY;
				} else {
					this.newRanges = [];
					this.newRanges.push({ day, room });
					this.monthSelected.days = this.monthSelected.days.map((daySelected) => {
						const newDaySelected = Object.assign({}, daySelected);
						newDaySelected.isSelected = false;
						newDaySelected.menu = false;
						if (isSameDay(daySelected.date, day.date)) {
							newDaySelected.isSelected = true;
							newDaySelected.menu = true;
						}
						return newDaySelected;
					});
					this.rooms = this.rooms.map((roomSelected) => {
						const newRoomSelected = Object.assign({}, roomSelected);
						newRoomSelected.isSelected = false;
						if (roomSelected.id === room.id) {
							newRoomSelected.isSelected = true;
						}
						return newRoomSelected;
					});
					this.checkInQuery = null;
					this.menuNewBooking = false;
				}
			} else {
				this.newRanges = [];
				this.newRanges.push({ day, room });
				this.monthSelected.days = this.monthSelected.days.map((daySelected) => {
					const newDaySelected = Object.assign({}, daySelected);
					newDaySelected.isSelected = false;
					newDaySelected.menu = false;
					if (isSameDay(daySelected.date, day.date)) {
						newDaySelected.isSelected = true;
						newDaySelected.menu = true;
					}
					return newDaySelected;
				});
				this.rooms = this.rooms.map((roomSelected) => {
					const newRoomSelected = Object.assign({}, roomSelected);
					newRoomSelected.isSelected = false;
					if (roomSelected.id === room.id) {
						newRoomSelected.isSelected = true;
					}
					return newRoomSelected;
				});
				this.checkInQuery = null;
				this.menuNewBooking = false;
			}
		} else {
			this.newRanges = [];
			this.newRanges.push({ day, room });
			this.monthSelected.days = this.monthSelected.days.map((daySelected) => {
				const newDaySelected = Object.assign({}, daySelected);
				newDaySelected.isSelected = false;
				newDaySelected.menu = false;
				if (isSameDay(daySelected.date, day.date)) {
					newDaySelected.isSelected = true;
				}
				return newDaySelected;
			});
			this.rooms = this.rooms.map((roomSelected) => {
				const newRoomSelected = Object.assign({}, roomSelected);
				newRoomSelected.isSelected = false;
				if (roomSelected.id === room.id) {
					newRoomSelected.isSelected = true;
				}
				return newRoomSelected;
			});
			this.checkInQuery = null;
			this.menuNewBooking = false;
			this.menuBooking = false;
		}
	}

	async function noShowBooking() {
		await this.$http.put(`${process.env.PMS_URL}/booking/no-show`, this.noShowModel);
		this.showNotification('La reserva ha sido liberada por no-show.', 'success');
		this.closeBookingModal('NoShow');
		this.loadData(this.roomTypeSelected);
	}

	function onChangeRoomType() {
		if (this.bookingSelected) {
			this.bookingSelected = null;
			this.$router.push({ name: 'calendar' });
		}
	}

	function onChangeSubsidiary() {
		if (this.bookingSelected) {
			this.bookingSelected = null;
			this.$router.push({ name: 'calendar' });
			this.loadData();
		}
	}

	function openCancelBooking() {
		this.monthSelected.days = this.monthSelected.days.map((d) => {
			const newD = { ...d };
			newD.menu = false;
			return newD;
		});
		this.modalCancelBooking = true;
	}

	function openNoShowBooking() {
		this.noShowModel.codeBooking = this.customerInfo.customer.bookingCode;
		this.modalNoShowBooking = true;
	}

	function pickRanges() {
		this.pickMonths = false;
		this.monthId = 0;
		this.yearSelected = 0;
		this.yearRange = getYear(this.dateStart);
	}

	async function seeBooking() {
		const codeBooking = this.customerInfo.customer.bookingCode;
		const { data: booking } = await this.$http.get(`${process.env.PMS_URL}/bookings/${codeBooking}`);
		const bookingData = booking.data.summary.booking;
		booking.data.quantity = Number(bookingData.adults) + Number(bookingData.childrens);
		booking.data.customer.data.documentName = booking.data.customer.data.documentType === 1
			? 'DNI' : 'RUC';
		if (booking.data.customerAditional && booking.data.customerAditional.length > 0) {
			booking.data.customerAditional = booking.data.customerAditional.map((cusAdd) => {
				const newCusAdd = { ...cusAdd };
				if (cusAdd.documentType === 1) {
					newCusAdd.documentName = 'DNI';
				} else if (cusAdd.documentType === 2) {
					newCusAdd.documentName = 'Pasaporte';
				} else if (cusAdd.documentType === 3) {
					newCusAdd.documentName = 'Carnet de Extranjería';
				} else {
					newCusAdd.documentName = 'RUC';
				}
				return newCusAdd;
			});
		}
		const channel = booking.data.channel ? booking.data.channel.data :
			{ inputInformations: [] };
		if (channel.inputInformations.length > 0) {
			const questions = channel.questions || {};
			channel.inputInformations.forEach((input) => {
				const keySelected = Object.keys(questions).find(key => key === input.value);
				questions[input.label] = questions[keySelected];
			});
			booking.data.channel.data.questions = questions;
		}
		this.seeModel = booking.data;
		this.modalSeeBooking = true;
	}

	function setYearSelected(year) {
		const id = this.monthId || new Date().getMonth() + 1;
		this.pickMonths = true;
		this.dateStart = null;
		this.dateEnd = null;
		this.yearSelected = year || this.yearSelected;
		this.monthActive(id, true);
	}

	function showCustomerInfo(e, room, customer, day) {
		this.menuBooking = false;
		this.menuNewBooking = false;
		const changeZIndex = true;
		const exonerated = customer.flagTaxes ? 'Sí' : 'No';
		this.customerInfo = { room, customer, day, changeZIndex, exonerated };
		this.rooms = this.rooms.map((roomS) => {
			const newRoom = Object.assign({}, roomS);
			newRoom.isSelected = false;
			return newRoom;
		});
		this.monthSelected.days = this.monthSelected.days.map((dayS) => {
			const newDay = Object.assign({}, dayS);
			newDay.isSelected = false;
			return newDay;
		});
		this.$nextTick(() => {
			e.preventDefault();
			this.xBooking = e.clientX;
			this.yBooking = e.clientY;
			this.menuBooking = true;
		});
	}

	function showDates() {
		const days = eachDay(this.dateStart, this.dateEnd);
		this.pickMonths = false;
		this.yearSelected = 0;
		this.monthId = 0;
		this.yearRange = getYear(this.dateStart);
		this.monthSelected = {};
		this.monthSelected.days = days.map((day, index) => {
			const newDay = Object.assign({}, day);
			newDay.id = index + 1;
			newDay.date = day;
			newDay.day = getDate(day);
			newDay.month = getMonth(day) + 1;
			newDay.value = getDay(day);
			newDay.isWeekend = isWeekend(day);
			newDay.shortDay = this.shortDays[getDay(day)];
			newDay.isSelected = false;
			if (index === 0) {
				this.monthSelected.id = getMonth(day) + 1;
			}
			if ((index + 1) === days.length) {
				this.monthSelected.endMonth = getMonth(day) + 1;
			}
			return newDay;
		});
		if (!this.bookingCode) {
			this.loadData();
		}
	}

	function showName(dayIndex, { initDay, dates }, day) {
		let showInDay = false;
		for (let index = 0; index < dates; index += 1) {
			if ((initDay + (index + 1)) === day) {
				showInDay = true;
			}
		}
		const showInOtherTag = (dayIndex === 0) && showInDay;
		return showInOtherTag;
	}

	function toggleIconStartDate() {
		this.onChange = !this.startDate;
	}

	function toggleIconEndDate() {
		this.onChange = !this.endDate;
	}

	function goToDetailGuest(hotelId, roomTypeId, code = 'billing') {
		const query = {
			initDate: format(this.customerInfo.customer.dateRange[0], 'YYYY-MM-DD'),
			endDate: format(this.customerInfo.customer.dateRange[1], 'YYYY-MM-DD'),
			roomId: this.customerInfo.room.id,
			bookingCode: this.customerInfo.customer.bookingCode,
			active: 'tab-1',
			code,
		};
		const route = this.$router.resolve({
			name: 'checkin-form-tabs',
			params: {
				hotelId,
				roomTypeId,
			},
			query,
		});
		window.open(route.href, '_blank');
	}

	function validations() {
		return {
			cancelModel: {
				description: {
					required,
				},
				title: {
					required,
				},
			},
		};
	}

	function validationTakenDay(customer, day) {
		const flag = (
			Number(customer.initYear) === this.yearSelected || Number(customer.initYear) === this.yearRange)
			&& (customer.initMonth === day.month || customer.endMonth === day.month)
			&& (customer.allDaysOnInitMonth.findIndex(ad => ad.day === day.day
			&& ad.month === day.month) > -1);
		return flag;
	}

	function dayTaken(room, day) {
		return room.days.findIndex(rd => this.methodIsSameDay(rd.date, day.date) && rd.isTaken) > -1;
	}

	function validationAdvancePayment({ customer }) {
		const valid = (Number(customer.bookingState) === 4
		|| Number(customer.bookingState) === 1
		|| Number(customer.bookingState) === 7)
		&& !this.expiredReservation;
		return valid;
	}

	function validationCheckOut({ customer }) {
		const valid = (Number(customer.bookingState) === 2
		|| Number(customer.bookingState) === 7)
		&& !this.expiredReservation;
		return valid;
	}

	function noShowOption({ customer }) {
		const bookingStateRight = Number(customer.bookingState) === 1
		|| Number(customer.bookingState) === 4;
		const noShow = this.isNoShow;
		return bookingStateRight && noShow;
	}

	function getCheckoutHours(date) {
		let hours = null;
		if (date) {
			const separate = date.split(' ');
			hours = separate[1];
		}
		return hours;
	}

	function goToBookingNew() {
		this.$router.push({ name: 'booking-new', query: { hotelId: this.subsidiary } });
	}

	function data() {
		return {
			createHref: { name: 'booking-new' },
			roomTypeIdSelect: [],
			bookingSelected: null,
			cancelModel: {
				description: '',
				title: '',
			},
			checkInQuery: null,
			contentClassModal: '',
			customerInfo: {
				customer: {
					id: null,
					dateRange: [],
					allDaysOnInitMonth: [],
				},
			},
			customerSelected: {},
			dateEnd: '',
			dateStart: '',
			daySelected: {},
			doNothing: false,
			footer: [],
			formatted: null,
			freeRooms: [],
			menuBooking: false,
			menuEnd: false,
			menuNewBooking: false,
			menuStart: false,
			modalCancelBooking: false,
			modalNoShowBooking: false,
			modalSeeBooking: false,
			monthId: new Date().getMonth() + 1,
			months: [
				{
					id: 1,
					name: 'Ene',
					active: false,
					days: [],
				},
				{
					id: 2,
					name: 'Feb',
					active: false,
					days: [],
				},
				{
					id: 3,
					name: 'Mar',
					active: false,
					days: [],
				},
				{
					id: 4,
					name: 'Abr',
					active: false,
					days: [],
				},
				{
					id: 5,
					name: 'May',
					active: false,
					days: [],
				},
				{
					id: 6,
					name: 'Jun',
					active: true,
					days: [],
				},
				{
					id: 7,
					name: 'Jul',
					active: false,
					days: [],
				},
				{
					id: 8,
					name: 'Ago',
					active: false,
					days: [],
				},
				{
					id: 9,
					name: 'Sep',
					active: false,
					days: [],
				},
				{
					id: 10,
					name: 'Oct',
					active: false,
					days: [],
				},
				{
					id: 11,
					name: 'Nov',
					active: false,
					days: [],
				},
				{
					id: 12,
					name: 'Dic',
					active: false,
					days: [],
				},
			],
			monthSelected: {},
			newRanges: [],
			noShowDate: false,
			noShowModel: {
				codeBooking: '',
				date: format(new Date(), 'YYYY-MM-DD'),
				flagBilling: false,
			},
			onChange: false,
			onChangeDate: false,
			onChangeEnd: false,
			pickMonths: true,
			roomList: 0,
			rooms: [],
			roomSelected: {},
			roomsList: [],
			roomsTaken: [],
			roomTypes: [],
			roomTypeSelected: 0,
			seeModel: {
				channel: { data: { questions: {} } },
				customer: { data: { country: {}	} },
			},
			shortDays: ['dom', 'lun', 'mar', 'mie', 'jue', 'vie', 'sab'],
			showDateBarFixed: false,
			subsidiaries: [],
			subsidiary: 0,
			today: format(new Date(), 'DD MMMM YYYY', { locale: esLocale }),
			xBooking: 0,
			xNewBooking: 0,
			yBooking: 0,
			yNewBooking: 0,
			years: [
				2017,
				2018,
				2019,
				2020,
				2021,
				2022,
				2023,
				2024,
				2025,
				2026,
				2027,
			],
			yearSelected: new Date().getFullYear(),
			yearRange: 0,
		};
	}

	export default {
		name: 'cms-calendar',
		components: {
			ButtonCreate,
			amountsComponent,
			generalAvailability,
		},
		computed: {
			arrowIcon,
			arrowIconEnd,
			arrowIconStart,
			expiredReservation,
			isNoShow,
		},
		data,
		filters: {
			parseDate,
			round,
		},
		methods: {
			loadAvailability,
			assignBooking,
			calculateLength,
			cancelBooking,
			changeEndIcon,
			changeFormatDate,
			changeIcon,
			changeIconDate,
			closeBookingModal,
			closeMenuBooking,
			closeMenuNew,
			daysByMonth,
			dayTaken,
			downloadCardTravel,
			dragEvent,
			dropEvent,
			fixedBarDateCalculations,
			getCheckoutHours,
			goToBilling,
			goToCheckIn,
			goToCheckOut,
			goToDetailGuest,
			goToPrepayment,
			goToReserve,
			goToUpdateBooking,
			hideCustomerInfo,
			isAfterMethod,
			loadBooking,
			loadData,
			loadParams,
			loadRoomsList,
			loadTypeRooms,
			methodIsAfter,
			methodIsSameDay,
			monthActive,
			newBooking,
			noShowBooking,
			noShowOption,
			onChangeRoomType,
			onChangeSubsidiary,
			openCancelBooking,
			openNoShowBooking,
			pickRanges,
			seeBooking,
			setYearSelected,
			showCustomerInfo,
			showDates,
			showName,
			toggleIconEndDate,
			toggleIconStartDate,
			validationAdvancePayment,
			validationCheckOut,
			validationTakenDay,
			goToBookingNew,
		},
		mixins: mixin,
		mounted,
		props: ['bookingCode'],
		validations,
		watch: {
			bookingCode,
		},
	};
</script>

<style lang="scss" scoped>
	.add-new {
		color: #ededf3;
		font-size: 30px;
		line-height: normal;
	}

	.container-calendar {
		background-color: white;
		height: calc(100vh - 130px);
		padding: 16px 10px 11px;
	}

	.base-calendar {
		border-collapse: collapse;
		border-spacing: 0;
		display: block;
		height: calc(100vh - 233px);
		overflow: auto;
		width: 100%;
	}

	.thead-calendar {
		border: 1px solid map-get($map: $colors, $key: table-border);
		display: block;
		height: 100%;
	}

	.main-row {
		display: block;
		height: 100%;
		position: relative;

		&:before,
		&:after {
			display: table;
			content: '';
		}

		&:after {
			clear: both;
		}
	}

	.row-calendar {
		display: table;
		width: 100%;

		&.row-calendar-body {
			display: flex;
			height: 40px;
			position: relative;

			.col-calendar-1 {
				border: 0.5px solid map-get($colors, table-border);
				min-width: 43px;
				padding: 0px;
				width: 100%;

				&.day-is-weekend {
					background-color: map-get($colors, is-weekend);
				}

				&.day-is-selected {
					&:not(.day-is-taken) {
						.tag-container {
							border: 2px solid map-get($colors, default-skyblue);
						}
					}

					.tag-container:not(.no-tag) + .tag-container.no-tag {
						border: 0px;
					}

					&.day-is-taken {
						.tag-init-day:after,
						.tag-end-day:after {
							border: 2px solid map-get($colors, default-skyblue);
							content: '';
							display: block;
							height: 100%;
							position: relative;
							width: 60%;
						}

						.tag-end-day:after {
							left: 24px;
						}

						.tag-init-day:after {
							left: -27px;
							width: 100%;
						}
					}
				}

				&:last-child {
					overflow: hidden;
				}
			}

			&:nth-child(2) {
				height: 41px;

				.col-calendar-1 {
					border-top: 2px solid map-get($colors, table-border);
				}
			}

			&:nth-last-child(3) {
				.col-calendar-1 {
					border-bottom: 2px solid map-get($colors, table-border);
					height: 41px;
				}
			}
		}

		&.row-calendar-footer {
			display: flex;
			height: 18.5px;

			.col-calendar-1 {
				background-color: map-get($map: $colors, $key: header-dark);
				min-width: 43px;
				width: 100%;

				.text-footer {
					color: white;
					font-family: map-get($map: $fonts, $key: bold);
					font-size: map-get($map: $sizes, $key: eleven);
					line-height: 2;
					padding: 0px;
					text-align: center;
				}
			}

			&:last-child {
				.col-calendar-1 {
					.text-footer {
						font-size: 9px;
					}
				}
			}
		}

		&.row-rooms {
			border-bottom: 2px solid map-get($colors, table-border);
			border-right: 0.5px solid map-get($colors, table-border);
			color: map-get($colors, grey-blue);
			font-family: map-get($fonts, medium);
			font-size: map-get($sizes, thirdteen);
			height: 38px;
			line-height: 38px;
			text-align: left;

			&:nth-child(3) {
				border-top: 1px solid map-get($colors, table-border);
			}

			.row-rooms-text {
				padding-left: 6px;
			}
		}

		&.row-days {
			display: flex;

			.col-calendar-1 {
				color: map-get($colors, grey-label);
				line-height: 13px;
				min-width: 43px;
				width: 100%;

				p {
					font-family: map-get($fonts, regular);
					font-size: map-get($sizes, eleven);
					margin: 0px;
				}

				span {
					font-family: map-get($fonts, semibold);
					font-size: map-get($sizes, twelve);
				}
			}
		}

		&.row-left {
			width: 111px;

			&-footer {
				border-right: 2px solid map-get($colors, table-border);
				background-color: map-get($map: $colors, $key: header-dark);
				height: 18.5px;
				width: 112px;

				.text-footer {
					color: white;
					font-family: map-get($map: $fonts, $key: bold);
				}
			}
		}

		.text-footer {
			color: map-get($colors, grey-label);
			font-size: 12px;
			padding-left: 7px;
			text-align: left;
		}
		&.row-calendar-total-availability {
			height: auto;
		}
	}

	.col-calendar {
		display: table-cell;
		vertical-align: middle;

		&-4 {
			float: left;
			height: auto;
			width: 111px;
		}

		&-31 {
			align-self: center;
			float: left;
			height: auto;
			overflow: auto;
			position: relative;
			width: calc(100% - 111px);
		}

		&-1 {
			width: calc(100% / 31);
		}
	}

	p {
		margin: 0px;
	}

	.tag {
		display: block;
		height: 26.5px;
		line-height: 26.5px;
		margin: 0 !important;
		padding: 0px;
		position: absolute;
		text-align: left;
		transform: skewX(-28deg);
		width: 106%;

		&.z-index {
			z-index: 1;
		}

		&-init-day {
			left: auto;
			padding-left: 5px;
			right: -10px;
			width: 54%;
			z-index: 1;
		}

		span.tag-name {
			color: white;
			overflow: hidden;
			position: absolute;
			transform: skewX(28deg);
			white-space: nowrap;
			width: max-content;
			z-index: 1;
		}

		&-end-day {
			left: -1px;
			right: auto;
			transform: skewX(-28deg);
			width: 50%;
		}

		&-container {
			height: 27px;
			margin-top: 5.5px;
			position: relative;
		}

		&-information {
			background-color: rgba(255, 255, 255, .96);
			border: .5px solid map-get($colors, border-tooltip);
			border-radius: 10px;
			box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .2);
			padding: 14px 18px;
			position: absolute;
			right: -120px;
			top: 20px;
			width: 219px;
			z-index: 2;

			.title {
				color: map-get($colors, blue-title);
				font-family: map-get($fonts, bold);
				font-size: 14px;
				margin-bottom: 8px;
				text-align: left;
				text-transform: uppercase;
			}

			.content {
				&-row {
					font-family: map-get($fonts, medium);
					font-size: 14px;
					margin-top: 10px;
					text-align: left;

					label {
						color: map-get($colors, default-skyblue);
						font-family: map-get($fonts, bold);
					}

					span {
						color: map-get($colors, clock-grey);
					}
				}
			}
		}

		&-menu {
			&-modal {
				height: 100%;
				width: 100%;
			}

			&-title {
				color: map-get($colors, blue-title);
				font-family: map-get($fonts, bold);
				font-size: map-get($sizes, fourteen);
			}

			&-body {
				label {
					color: map-get($colors, default-skyblue);
					font-family: map-get($fonts, bold);
					font-size: map-get($sizes, fourteen);
				}

				span {
					color: map-get($colors, tag-menu-span);
					font-family: map-get($fonts, regular);
					font-size: map-get($sizes, fourteen);
				}
			}

			&-sidebar {
				border-bottom-left-radius: 10px;
				border-bottom-right-radius: 10px;
				height: 100%;

				.list__tile__title,
				.list__tile__action {
					color: map-get($colors, dark);
					font-family: map-get($fonts, regular);
					font-size: map-get($sizes, twelve);
				}

				.list__tile__action {
					color: map-get($colors, tag-menu-icon);
					padding-left: 16px;

					i {
						font-size: map-get($sizes, sixteen);
					}
				}

				li {
					border-bottom: 1px solid rgba(0, 0, 0, .12);

					&:last-child {
						border-bottom: 0px;
					}
				}
			}

			&-border {
				border-right: 1px solid rgba(0, 0, 0, .12);
			}
		}
	}

	.select {
		position: relative;
		text-align: left;

		select.select-roomtype {
			color: map-get($colors, arrow-icon);
			font-size: map-get($sizes, eleven);
			height: 27px;
			outline: none;
			position: relative;
			width: 100%;
		}
	}

	.header-booking-data {
		height: 31px;
		position: absolute;
		right: 20px;
		text-align: right;
		top: 52px;
		width: calc(100% - 230px);

		&-calendar {
			margin: 0px !important;
			position: static;
			width: 100%;
		}

		div {
			padding-bottom: 0px !important;
			padding-top: 0px !important;
		}

		p {
			color: map-get($colors, blue-title);
			font-family: map-get($fonts, regular);
			font-size: 10px;
			margin: 0px;
			text-transform: uppercase;
		}

		span {
			color: map-get($colors, default-skyblue);
			font-family: map-get($fonts, medium);
			font-size: 15px;
		}

		.border-select {
			border-right: 1px solid map-get($colors, border-radio);
			margin-right: 16px;
			padding-right: 16px !important;
		}
	}

	.tasks-calendar-header {
		margin-bottom: 16px;

		.title {
			color: map-get($colors, bg-chart);
			font-family: map-get($fonts, medium);
			font-size: 11px !important;
			text-align: left;
		}

		.period {
			text-align: right;

			label {
				color: map-get($colors, grey-label);
				font-family: map-get($fonts, regular);
				font-size: map-get($sizes, fourteen);
				margin-left: 14px;
			}

			.active {
				border-bottom: 1px solid map-get($colors, bg-chart);
				color: map-get($colors, bg-chart);
				font-family: map-get($fonts, medium);
			}

			.select {
				border-left: 1px solid map-get($colors, year-select);
				display: inline-block;
				height: 13px;
				line-height: 13px;
				margin-left: 4px;
				position: relative;
				text-align: left;
				width: 52px;

				&.select-calendar {
					width: auto;
				}
			}
		}

		.button-ranges {
			border-radius: 5px;
			box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, .18);
			color: map-get($colors, bg-chart);
			outline: none;
			padding: 0px 8px;
		}
	}

	.assign-room {
		min-width: auto !important;
	}

	.size-btn {
		height: auto;
		width: auto;
	}

	.mb-8 {
		margin-bottom: 8px;
	}

	.border-right {
		border-right: 1px solid map-get($map: $colors, $key: e-bg-icon);
	}

	.caption {
		.color {
			border-radius: 3px;
			display: inline-block;
			height: 10px;
			margin-right: 4px;
			vertical-align: middle;
			width: 10px;

			&.check-in {
				background-color: map-get($map: $colors, $key: check-in);
			}

			&.check-out {
				background-color: map-get($map: $colors, $key: check-out);
			}

			&.taken {
				background-color: map-get($map: $colors, $key: taken);
			}

			&.locked {
				background-color: map-get($map: $colors, $key: locked);
			}
			&.in-house {
				background-color: rgb(53, 59, 81);
			}
		}

		.title {
			color: map-get($map: $colors, $key: color-selected-item);
			font-family: map-get($map: $fonts, $key: regular);
			font-size: map-get($map: $sizes, $key: fourteen);
			vertical-align: middle;
		}
	}

	.taken-bar {
		color: map-get($map: $colors, $key: taken-text);
		font-family: map-get($map: $fonts, $key: medium);
		font-size: map-get($map: $sizes, $key: eleven);
	}

	.row-taken-bar {
		background-color: map-get($map: $colors, $key: taken-bar);

		.col-calendar {
			background-color: map-get($map: $colors, $key: taken-bar);
		}
	}

	.btn-cancel {
		&.grey {
			background-color: map-get($colors, tag-menu-span) !important;
		}
	}

	.headline {
		border-bottom: 1px solid map-get($colors, border-modal);
		color: map-get($colors, realtime-label);
		font-family: map-get($fonts, regular);
		font-size: map-get($sizes, fourteen) !important;
		text-transform: capitalize;

		&-title {
			color: map-get($colors, default-dark);
			font-size: map-get($sizes, eighteen);
			font-weight: normal;
			margin: 0px;
			text-transform: none;
		}

		&-label {
			color: map-get($colors, bg-chart);
			font-family: map-get($fonts, medium);
		}
	}

	.bar-data {
		align-items: center;
		background-color: white;
		box-shadow: 0 2px 5px 0 rgba($color: #000000, $alpha: .1);
		display: flex;
		height: 48px;
		justify-content: space-around;

		&-item {
			border-right: 1px solid map-get($colors, year-select);
			flex: 1 auto;

			&:last-of-type {
				border-right: 0px;
			}

			&.no-border {
				border-right: 0px;
			}

			p {
				color: map-get($colors, bg-chart);
				font-family: map-get($fonts, medium);
				font-size: map-get($sizes, fourteen);
				margin-bottom: 0px;

				span {
					color: map-get($colors, realtime-label);
					font-family: map-get($fonts, regular);
					font-size: map-get($sizes, fourteen);
				}
			}
		}

		.bar-icon {
			font-size: map-get($map: $sizes, $key: twenty);
			justify-content: flex-start;
			width: 20px;
		}
	}

	.modal {
		&-label {
			color: map-get($colors, dark);
			font-family: map-get($fonts, medium);
			font-size: map-get($sizes, fourteen);
		}

		&-text {
			color: map-get($colors, dark);
			font-family: map-get($fonts, regular);
			font-size: map-get($sizes, fourteen);
		}
	}

	.date-bar-fixed {
		height: 27px;
		position: sticky;
		top: 0;
		z-index: 4;
	}
</style>



// WEBPACK FOOTER //
// CmsCalendar.vue?3073b06e